export const getTotalPendingChangesCount = ({ pendingChangesCounts, data }) =>
  data.reduce((acc, { id }) => (acc += pendingChangesCounts[id] ?? 0), 0);
